/**
 * Custom Hook: useNFC
 * Maneja operaciones NFC
 */

import { useState, useCallback } from 'react';
import nfcService from '../services/nfcService';
import { NFC_STATES } from '../utils/constants';

export const useNFC = () => {
  const [nfcState, setNfcState] = useState(NFC_STATES.IDLE);
  const [nfcData, setNfcData] = useState(null);
  const [error, setError] = useState(null);

  const isSupported = nfcService.isNFCSupported();

  const startScan = useCallback(async () => {
    setNfcState(NFC_STATES.SCANNING);
    setError(null);
    setNfcData(null);

    try {
      await nfcService.scan(
        // onReading callback
        (data) => {
          setNfcData(data);
          setNfcState(NFC_STATES.SUCCESS);
        },
        // onError callback
        (err) => {
          setError(err.message);
          setNfcState(NFC_STATES.ERROR);
        }
      );
    } catch (err) {
      setError(err.message);
      setNfcState(NFC_STATES.ERROR);
    }
  }, []);

  const writeNFC = useCallback(async (data) => {
    setNfcState(NFC_STATES.WRITING);
    setError(null);

    try {
      const result = await nfcService.write(data);
      
      if (result.success) {
        setNfcState(NFC_STATES.SUCCESS);
        return { success: true };
      }
      
      throw new Error('Error escribiendo en NFC');
    } catch (err) {
      setError(err.message);
      setNfcState(NFC_STATES.ERROR);
      return { success: false, error: err.message };
    }
  }, []);

  const updateBalance = useCallback(async (estudianteId, newBalance) => {
    return await nfcService.updateBalance(estudianteId, newBalance);
  }, []);

  const reset = useCallback(() => {
    setNfcState(NFC_STATES.IDLE);
    setNfcData(null);
    setError(null);
    nfcService.stopScan();
  }, []);

  return {
    nfcState,
    nfcData,
    error,
    isSupported,
    startScan,
    writeNFC,
    updateBalance,
    reset
  };
};

export default useNFC;
